<template lang="pug">
  div(class="documents-sign-results")
    div(class="documents-sign-results__icon")
      v-img(
        :src="icon"
        max-width="80"
      )
    h2(class="title-32px bold mb-2") {{ $t(title) }}
    div(class="text-14px light") {{ text }}
    div(
      v-if="failedDocuments.length"
      class="documents-sign-results__failed-documents"
    )
      div(
        v-for="(document, idx) in failedDocuments"
        :key="idx"
        class="documents-sign-results__failed-item"
      )
        div(class="d-flex align-center justify-space-between")
          div(class="text-left")
            div(class="text-14px light") {{ document.title }}
            div(v-if="document.reason")
              div(class="text-12px dark pr-1") {{ $t('EDS key error') }}:
              div(
                class="documents-sign-results__failed-item-reason documents-sign-results__failed-item-reason--error"
              ) {{ document.reason }}
            div(v-if="document.stampReason")
              div(class="text-12px dark pr-1") {{ $t('Stamp key error') }}:
              div(
                class="documents-sign-results__failed-item-reason documents-sign-results__failed-item-reason--error"
              ) {{ document.stampReason }}
          div
            div(class="documents-sign-results__failed-item-icon")
              e-svg-icon close-circle-red
    div(class="documents-sign-results__actions")
      v-btn(
        class="main-button w-100"
        @click="handleClick"
      ) {{ $t('Ok') }}
</template>

<script>
export default {
  name: 'BlockDocumentsSignResults',
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    failedDocuments: {
      type: Array,
      default: () => []
    },
    isInsideModal: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: () => require('~/assets/images/party-popper.png')
    },
    title: {
      type: String,
      default: 'Documents signed'
    }
  },
  computed: {
    text() {
      return this.failedDocuments.length
        ? this.$t(
            'The process completed with some errors. Please check the indicated errors and try to sign these documents again'
          )
        : this.$t('All selected documents were successfully signed')
    }
  },
  methods: {
    handleClick() {
      if (this.isInsideModal) {
        this.closeModal()
      } else {
        this.$emit('back')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.documents-sign-results {
  &__icon {
    display: flex;
    justify-content: center;
    padding-bottom: 16px;
  }
  &__failed-documents {
    margin-top: 16px;

    border-radius: 12px;
    background: $background-secondary-alternative;
  }
  &__failed-item {
    padding: 12px;

    &-reason {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      padding-right: 8px;

      &--error {
        color: $danger;
      }
    }
  }
  &__actions {
    padding-top: 32px;
  }
}
</style>
